<template>
  <div>
    <main>
      <div class="box">
        <div>Cerrado!</div>
      </div>
      <h2>404 - Página no encontrada</h2>
      <p>La página que está buscando podría haber sido eliminada, su nombre pudo cambiar o puede que no esté disponible temporalmente.</p>
      <Btn action="router" type="white orange">Inicio</Btn>
    </main>
  </div>
</template>

<style>

.error {
  background-color: #f1b016 !important;
}

main h2 {
  font-size: 3.1vh;
  color: #fff !important;
}

main p {
  width: 40vw;
  margin: 1em auto;
  font-size: 2vh;
  color: #fff !important;
}

.box {
  text-align: center;
  position: relative;
  margin-top: 40vh;
  margin-bottom: 2em;
}

.box div {
  width: 35vh;
  padding: 0.1em;
  margin: auto;
  color: #f1b016;
  background-color: #fff;
  font-size: 280%;
  position: relative;
  text-transform: capitalize;
  animation: moving 8s linear infinite;
  -webkit-animation: moving 8s linear infinite;
  -moz-animation: moving 8s linear infinite;
  -o-animation: moving 8s linear infinite;
  transform-origin: 50% -400%;
  -webkit-transform-origin: 50% -400%;
  -moz-transform-origin: 50% -400%;
  -o-transform-origin: 50% -400%;
}

.box div:before {
  content: "";
  width: 3vh;
  height: 3vh;
  background-color: #fff;
  border-radius: 50%;
  display: block;
  position: absolute;
  left: 45.5%;
  top: -40vh;
}

.box div:after {
  content: "";
  width: 1%;
  height: 40vh;
  background-color: #fff;
  display: block;
  position: absolute;
  left: 49.5%;
  top: -40vh;
}

@media screen and (max-width: 767px) {
  body {
    padding: 20px 10px;
  }

  main p {
    width: 100%;
  }

  .box div {
    width: 35vh;
  }
}

@keyframes moving {
  0%,
  100% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(3deg);
  }
  50% {
    transform: rotate(-3deg);
  }
}

@-webkit-keyframes moving {
  0%,
  100% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(3deg);
  }
  50% {
    transform: rotate(-3deg);
  }
}

@-moz-keyframes moving {
  0%,
  100% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(3deg);
  }
  50% {
    transform: rotate(-3deg);
  }
}

@-o-keyframes moving {
  0%,
  100% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(3deg);
  }
  50% {
    transform: rotate(-3deg);
  }
}
</style>

<script>
import Btn from "../components/UIElements/Btn";

export default {
  components: { Btn },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  mounted() {
    this.toggleBodyClass("addClass", "error");
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "error");
  }
};
</script>
